import { EstadoBolsa } from './bolsaMachine';

// SPEC-097 — mapa color↔estado, único lugar de verdad (design.md §2.1).
export const TOKENS = {
  purple: '#93408F',
  purpleDark: '#6E2F6B',
  purpleSoft: '#B06CAD',
  ink: '#2E2430',
  text: '#5C4A5C',
  muted: '#A79AA7',
  faint: '#C9BFC9',
  hair: '#F0E9F0',
  bg: '#FDFCFD',
  wash: '#FAF7FA',
  green: '#2F9E63',
  blue: '#3B6FC9',
  amber: '#C98A1B',
  red: '#CB4444',
  gray: '#8B8B94',
  slate: '#55505E',
};

export const COLOR_POR_ESTADO: Record<EstadoBolsa, string> = {
  [EstadoBolsa.ACTIVA]: TOKENS.gray,
  [EstadoBolsa.BORRADOR]: TOKENS.blue,
  [EstadoBolsa.ENVIADA]: TOKENS.purple,
  [EstadoBolsa.GANADA]: TOKENS.green,
  [EstadoBolsa.PERDIDA]: TOKENS.red,
  [EstadoBolsa.VENCIDA]: TOKENS.slate,
  [EstadoBolsa.ANULADA]: TOKENS.faint,
  [EstadoBolsa.DISCARDED]: TOKENS.faint,
};
